import React from 'react';
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from 'react-pro-sidebar';

import {
  FaUsers,
  FaBuilding,
  FaList,
  FaStar,
  FaBook,
  FaUser,
  FaQuestion
} from 'react-icons/fa';

import {
  MdCopyright,
  MdOutlineQuestionAnswer,
  MdApartment,
  MdQuestionAnswer,
  MdComputer,
  MdClass,
  MdOutlineContentPaste,
  MdPrint
} from 'react-icons/md';

import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';

import Logo from '../assets/images/logo-ontest-branco.png';

import './sidebar.css';
import { usePreferences } from '../contexts/PreferencesContext';

const Aside = ({
  collapsed,
  toggled,
  handleToggleSidebar
}) => {

  const user_role = useSelector(
    store => store.AppReducer.user.role
  );

  const user = useSelector(
    store => store.AppReducer.user
  );
  const { t } = usePreferences();

  return (
    <ProSidebar
      collapsed={collapsed}
      toggled={toggled}
      breakPoint="md"
      className="modern-sidebar"
      onToggle={handleToggleSidebar}
    >

      <SidebarHeader className="sidebar-header">
        <div className="logo-wrapper">
          <img
            src={Logo}
            alt="OnTest"
          />
        </div>
      </SidebarHeader>

      {user_role === 'viwer' && (
        <SidebarContent>

          <Menu iconShape="circle">

            <MenuItem icon={<MdPrint />}>
              <NavLink
                exact
                to="/"
                activeClassName="menu-active"
              >
                {t('diagramLayouts')}
              </NavLink>
            </MenuItem>

          </Menu>

        </SidebarContent>
      )}

      {(user_role === 'region_admin' ||
        user_role === 'faculdade') && (

          <SidebarContent>

            <Menu iconShape="circle">

              <MenuItem icon={<MdApartment />}>
                <NavLink
                  exact
                  to="/"
                  activeClassName="menu-active"
                >
                  {(user?.empresa == null ||
                    user?.empresa?.change_text === false)
                    ? t('organizations')
                    : t('processes')}
                </NavLink>
              </MenuItem>

              {user?.empresa?.plan?.training && (

                <SubMenu
                  title={t('trainingManagement')}
                  icon={<MdClass />}
                >

                  <MenuItem icon={<MdOutlineContentPaste />}>
                    <NavLink
                      to="/conteudos"
                      activeClassName="menu-active"
                    >
                      {t('contents')}
                    </NavLink>
                  </MenuItem>

                  <MenuItem icon={<FaList />}>
                    <NavLink
                      to="/modulos"
                      activeClassName="menu-active"
                    >
                      {t('modules')}
                    </NavLink>
                  </MenuItem>

                  <MenuItem icon={<FaList />}>
                    <NavLink
                      to="/treinamentos"
                      activeClassName="menu-active"
                    >
                      {t('trainings')}
                    </NavLink>
                  </MenuItem>

                </SubMenu>

              )}

              <MenuItem icon={<MdOutlineQuestionAnswer />}>
                <NavLink
                  exact
                  to="/disciplinas"
                  activeClassName="menu-active"
                >
                  {t('disciplines')}
                </NavLink>
              </MenuItem>

              <MenuItem icon={<FaBook />}>
                <NavLink
                  exact
                  to="/banca-questoes"
                  activeClassName="menu-active"
                >
                  {t('publicQuestions')}
                </NavLink>
              </MenuItem>

              {(user.role === 'region_admin' ||
                !user?.empresa?.hide_questionario) && (

                  <MenuItem icon={<FaQuestion />}>
                    <NavLink
                      exact
                      to="/questionarios"
                      activeClassName="menu-active"
                    >
                      {t('questionnaires')}
                    </NavLink>
                  </MenuItem>

                )}

              <SubMenu
                title={t('assessmentBank')}
                icon={<MdQuestionAnswer />}
              >

                <MenuItem icon={<FaUser />}>
                  <NavLink
                    to="/elaboradores"
                    activeClassName="menu-active"
                  >
                    {t('authors')}
                  </NavLink>
                </MenuItem>

                <MenuItem icon={<FaList />}>
                  <NavLink
                    to="/demandas"
                    activeClassName="menu-active"
                  >
                    {t('demands')}
                  </NavLink>
                </MenuItem>

                <MenuItem icon={<FaList />}>
                  <NavLink
                    to="/recursos"
                    activeClassName="menu-active"
                  >
                    {t('questionResources')}
                  </NavLink>
                </MenuItem>

                <MenuItem icon={<FaStar />}>
                  <NavLink
                    to="/avaliar-questoes"
                    activeClassName="menu-active"
                  >
                    {t('evaluateQuestions')}
                  </NavLink>
                </MenuItem>

              </SubMenu>

              {user_role === 'region_admin' && (

                <MenuItem icon={<FaBuilding />}>
                  <NavLink
                    exact
                    to="/organizadoras"
                    activeClassName="menu-active"
                  >
                    {t('adminOrganizer')}
                  </NavLink>
                </MenuItem>

              )}

              {user?.empresa?.owner_id === user?.id && (

                <MenuItem icon={<FaUsers />}>
                  <NavLink
                    exact
                    to="/membros"
                    activeClassName="menu-active"
                  >
                    {t('teamMembers')}
                  </NavLink>
                </MenuItem>

              )}

              <MenuItem icon={<MdComputer />}>
                <NavLink
                  exact
                  to="/system"
                  activeClassName="menu-active"
                >
                  {t('systemModules')}
                </NavLink>
              </MenuItem>

            </Menu>

          </SidebarContent>

        )}

      <SidebarFooter className="sidebar-footer">

        <a
          href="https://www.ontest.com.br"
          target="_blank"
          rel="noopener noreferrer"
          className="copyright-link"
          style={{display:'flex',justifyContent:'center',alignItems:'center'}}
        >
          <MdCopyright style={{marginRight:2}} />
          <div>
            OnTest {moment().format('YYYY')}
          </div>
        </a>

      </SidebarFooter>

    </ProSidebar>
  );
};

export default Aside;
